import React from 'react';
import { Button, Container, Paper, Typography } from '@mui/material';
import TextFieldCustom from '../../../../components/TextField/TextFieldCustom';
import Loader from '../../../../components/Loader/Loader';
import RadioButton from '../../../../components/RadioButton/RadioButton';
import Grid from '@mui/material/Unstable_Grid2';
import useFieldsCreatorPage from './useFieldsCreatorPage';
import { FIELDTYPE } from '../../../../constants/field-type';
import SelectCustom from '../../../../components/Select/SelectCustom';
import TableCustom from '../../../../components/Table/TableCustom';
import AlertBar from '../../../../components/AlertBar/AlertBar';

function FieldsCreatorPage() {

    const {
        formFieldState,
        buttonAction,
        fields,
        handleFieldChange,
        formName,
        formExists,
        tableColumns,
        tableItems,
        showAlert
    } = useFieldsCreatorPage();

    return (
        <div>
            <Container maxWidth="xxl" sx={{ mb: 4 }}>
                <Paper elevation={5} sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
                    {formExists ?
                        <>
                            <Typography variant="h5" sx={{ mb: 2, textAlign: 'center' }}> {formName} </Typography>
                            <Grid container spacing={2}>

                                {fields.map(field => {
                                    switch (field.fieldType) {
                                        case FIELDTYPE.TEXT:
                                            return <TextFieldCustom
                                                label={field.label}
                                                size={field.size}
                                                setValue={(val) => { handleFieldChange(val, field.fieldVal) }}
                                                value={formFieldState[field.fieldVal]}
                                                key={field.label}
                                                disable={field.disable}
                                                withInfo={field.withInfo}
                                                description={field.description}
                                            // setValue: (val) => handleFieldChange(val, field.FieldName2),
                                            />
                                        case FIELDTYPE.LONG_TEXT:
                                            return <TextFieldCustom
                                                label={field.label}
                                                size={field.size}
                                                setValue={(val) => { handleFieldChange(val, field.fieldVal) }}
                                                value={formFieldState[field.fieldVal]}
                                                key={field.label}
                                                disable={field.disable}
                                                withInfo={field.withInfo}
                                                description={field.description}
                                                multiline={true}
                                            // setValue: (val) => handleFieldChange(val, field.FieldName2),
                                            />
                                        case FIELDTYPE.NUMBER:
                                            return <TextFieldCustom
                                                label={field.label}
                                                size={field.size}
                                                type={field.type}
                                                setValue={(val) => { handleFieldChange(val, field.fieldVal) }}
                                                value={formFieldState[field.fieldVal]}
                                                key={field.label}
                                            // setValue: (val) => handleFieldChange(val, field.FieldName2),
                                            />
                                        case FIELDTYPE.RADIO:
                                            return <RadioButton
                                                label={field.label}
                                                options={field.options}
                                                setValue={(val) => { handleFieldChange(val, field.fieldVal) }}
                                                value={formFieldState[field.fieldVal]}
                                                size={field.size}
                                                key={field.label}

                                            />
                                        case FIELDTYPE.DROP_DOWN:
                                            return <SelectCustom
                                                label={field.label}
                                                options={field.options}
                                                setValue={(val) => { handleFieldChange(val, field.fieldVal) }}
                                                value={formFieldState[field.fieldVal]}
                                                size={field.size}
                                                key={field.label}

                                            />
                                        default:
                                            return null
                                    }

                                })}
                            </Grid>
                            <br></br>
                            {/* <Button color="primary" variant="outlined" onClick={buttonAction.handleCopy}> copy </Button> */}
                            <Button color="primary" variant="contained" onClick={buttonAction.handleSubmit}> Submit </Button>
                        </>
                        :
                        <Loader />
                    }
                </Paper>
                <Paper elevation={5} sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}>
                    {formExists &&
                        <TableCustom
                            columns={tableColumns}
                            rows={tableItems}
                        />
                    }
                </Paper>
                <AlertBar
                    showAlert={showAlert.show}
                    severity={showAlert.severity}
                    alertMessage={showAlert.message}
                />
            </Container>
        </div>
    );
}

export default FieldsCreatorPage;